import {
  ButtonGroup,
  createSvgIcon,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import React, {useState} from 'react';
import {PlayArrow, SkipNext, SkipPrevious} from "@mui/icons-material";
import PauseIcon from '@mui/icons-material/Pause';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CheckIcon from '@mui/icons-material/Check';
import './App.css';
import {appleMusicIconPath, bandcampIconPath, spotifiyIconPath} from "./icons/icon_paths";
import MidnightCall from './tracks/Dexter_Fizz_x_Bugseed_-_Midnight_Call.mp3'
import Glizzy from './tracks/Dexter_Fizz_x_Bugseed_-_Glizzy_in_Montevi_v2.mp3'
import IvsI from './tracks/Dexter_Fizz_x_Bugseed_-_i_vs_i_regular_v2.mp3'

const BandcampIcon = createSvgIcon(
    <path d={bandcampIconPath} />,
    'Bandcamp',
);
const SpotifyIcon = createSvgIcon(
    <path fill="currentColor" d={spotifiyIconPath}/>,
    'Spotify'
)

const AppleMusicIcon = createSvgIcon(
    <svg width="21" height="21" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32">
      <path fill="currentColor" d={appleMusicIconPath}/>
    </svg>,
    'Apple Music'
)
interface Track {
  name: String;
  audio: HTMLAudioElement;
}
const available_songs: Track[] = [
  {name: 'Midnight Call . feat. Lina & Curbside Jones', audio: new Audio(MidnightCall)},
  {name: 'Glizzy in Montevi', audio: new Audio(Glizzy)},
  {name: 'i vs i', audio: new Audio(IvsI)}
]

function secondsToMinutesSeconds(timeSeconds: number) {
  if (isNaN(timeSeconds)) {
    return '--:--'
  }
  const minutes = Math.floor(timeSeconds / 60);
  const seconds = Math.floor(timeSeconds % 60);
  return minutes.toString().padStart(2,'0') + ':' + seconds.toString().padStart(2,'0')
}

const song_codes = ["1xZC2%f30", "0ayGf9MzU", "6nD3ek51T"];
function App() {
  const [currentSongIndex, setCurrentSongIndex] = useState(0);
  const [unlockedSongs, setUnlockedSongs] = useState(0);
  const [isPlaying, setPlaying] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(NaN);
  const [inputCode, setInputCode] = useState("");

  const doPlay = (index: number) => {
    const play_promise = available_songs[index].audio.play();

    if (play_promise !== undefined) {
      play_promise.then(() => {
        available_songs[index].audio.ontimeupdate = () => {
          setTimeElapsed(available_songs[index].audio.currentTime)
        }
        available_songs[index].audio.onended = () => {
          if (index + 1 >= unlockedSongs) {
            doPlay(0)
          } else {
            doPlay(index + 1)
            setCurrentSongIndex(index + 1)
          }
        }
      }).catch(error => {})
    }
  }

  const unlockCodeChange = (event: any) => {
      setInputCode(event.target.value);
  };

  return (
    <div className="App" style={{height: '100vh'}}>
      <Grid container columns={12} style={{width: '100%', height: '100%', backgroundColor: 'black'}} spacing={0} margin={0}>
        <Grid item xs={6} style={{display: 'flex', justifyContent: 'center'}}>
          <Paper square style={{width: '100%', height: '100%',backgroundColor: '#123f5b'}} elevation={0}>
            <div className="gm4html5_div_class" id="gm4html5_div_id" style={{paddingTop: '20%'}}>
              <canvas
                  id="canvas"
                  width="800"
                  height="480"
                  onClick={() => {
                    const canvas = document.getElementById('canvas')!;
                    canvas.focus();
                  }}
                  tabIndex={0}
              >
                <p>Your browser doesn't support HTML5 canvas.</p>
              </canvas>
            </div>
            <TextField
                color='primary'
                id='unlock-code'
                label='Unlock Code'
                variant='standard'
                InputProps={{
                  startAdornment: (
                      <InputAdornment position='start'>
                        <LockOpenIcon color='primary'/>
                      </InputAdornment>
                  )
                }}
                value={inputCode}
                onChange={unlockCodeChange}
            />
            <IconButton
              color='primary'
              onClick={() => {
                const found = song_codes.indexOf(inputCode)
                if (found === -1) {
                  return
              }
              setUnlockedSongs(found + 1)
            }}>
              <CheckIcon/>
            </IconButton>
            {unlockedSongs > 0 &&
              <>
                <Typography color='primary'>{available_songs[currentSongIndex].name}</Typography>
                <ButtonGroup>
                  <IconButton color='primary' onClick={() => {
                    let updatedSongIndex = currentSongIndex - 1;
                    if (updatedSongIndex <= 0) {
                      updatedSongIndex = unlockedSongs - 1;
                    }
                    if (isPlaying) {
                      available_songs[currentSongIndex].audio.pause();
                      available_songs[currentSongIndex].audio.currentTime = 0;
                      doPlay(updatedSongIndex);
                    }
                    setCurrentSongIndex(updatedSongIndex);
                  }}>
                    <SkipPrevious/>
                  </IconButton>
                  <IconButton color='primary' onClick={() => {
                    if (isPlaying) {
                      available_songs[currentSongIndex].audio.pause();
                      setPlaying(false);
                    } else {
                      doPlay(currentSongIndex);
                      setPlaying(true);
                    }
                  }}>
                    {!isPlaying
                        ? <PlayArrow/>
                        : <PauseIcon/>
                    }
                  </IconButton>
                  <IconButton color='primary'  onClick={() => {
                    let updatedSongIndex = currentSongIndex + 1;
                    if (updatedSongIndex >= unlockedSongs) {
                      updatedSongIndex = 0;
                    }
                    if (isPlaying) {
                      available_songs[currentSongIndex].audio.pause();
                      available_songs[currentSongIndex].audio.currentTime = 0;
                      doPlay(updatedSongIndex);
                    }
                    setCurrentSongIndex(updatedSongIndex);
                  }}>
                    <SkipNext/>
                  </IconButton>
                </ButtonGroup>
                <Typography color='primary'>
                  {
                      (isNaN(available_songs[currentSongIndex].audio.duration)
                          ? '--:--'
                          : secondsToMinutesSeconds(timeElapsed)) + ' / '
                  }
                  {secondsToMinutesSeconds(available_songs[currentSongIndex].audio.duration)}
                </Typography>
              </>
            }
          </Paper>
        </Grid>
        <Grid item xs={6} style={{display: 'flex', justifyContent: 'center'}}>
          <Paper square  style={{width: '100%', height: '100%', backgroundColor: '#13304c'}} elevation={0}>
            <Grid container columns={12}>
              <Grid item xs={12}>
                <Paper square style={{width: '45%', marginLeft: '25%', marginTop: '20%', backgroundColor: '#0b666d'}}>
                  <Typography variant='h5' style={{color: '#07d0dd'}}>
                    Dexter Fizz
                  </Typography>
                  <Typography style={{color: '#07d0dd'}}>"other than that fuck em we ball "</Typography>
                  <Typography style={{color: '#07d0dd'}}>"No matter what happens, boy, keep that mafukka rollin"</Typography>
                  <Typography style={{color: '#07d0dd'}}>- curtis snow</Typography>
                  <Typography style={{color: '#07d0dd'}}>This is my music, I'm Dexter Fizz, support me on my quest of makin music to better the world, peace n love. enjoy share with ya friend.</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <IconButton onClick={() => {window.open('https://dexterfizz.bandcamp.com')}}>
                  <BandcampIcon/>
                </IconButton>
                <IconButton onClick={() => {window.open('https://open.spotify.com/artist/2BBWWTlAVdOnJvLowoz2ir?si=xB-vvmGzT7SplQbNroMA-A ')}}>
                  <SpotifyIcon/>
                </IconButton>
                <IconButton onClick={() => {window.open('https://music.apple.com/us/artist/dexter-fizz/590864162')}}>
                  <AppleMusicIcon/>
                </IconButton>
                <IconButton onClick={() => {window.open('https://www.instagram.com/dexterfizz/?hl=en')}}>
                  <InstagramIcon/>
                </IconButton>
                <IconButton onClick={() => {window.open('https://twitter.com/dexterfizz')}}>
                  <TwitterIcon/>
                </IconButton>
                <IconButton onClick={() => {window.open('https://soundcloud.com/dexter-fizz')}}>
                  <CloudQueueIcon/>
                </IconButton>             
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export default App;
